import type { StreamEvent } from "@plannello/shared";

/** `useLiveStatus()`: where the live connection of this browser stands. */
export type LiveStatus = "connecting" | "live" | "reconnecting" | "offline";

/** A message of the stream. The kind is open-ended on purpose: unknown kinds are ignored. */
export type LiveEvent = Omit<StreamEvent, "kind"> & { kind: string };

/** Every event name the server may send; EventSource only delivers names it was told about. */
export const STREAM_KINDS = [
  "item.created",
  "item.updated",
  "item.moved",
  "item.deleted",
  "item.restored",
  "item.upserted",
  "item.removed",
  "comment.created",
  "relation.created",
  "relation.deleted",
  "space.created",
  "product.created",
  "space.updated",
  "space.deleted",
  "product.deleted",
  "milestone.created",
  "milestone.updated",
  "schema.changed",
  "notification.created",
  "product.updated",
  "translation.updated",
  "translation.job",
  "feedback.changed",
  "note.created",
  "note.updated",
  "note.moved",
  "note.deleted",
  "note.restored",
  "resync",
] as const;
